import React, { useCallback } from "react";

import PropTypes from "prop-types";
import { Icon, Loader } from "semantic-ui-react";

import Dropdown from "components/Dropdown";
import { useDictionary } from "hooks";

import styles from "./styles.css";


const SearchBar = ({ className, options, onChange, value, loading, ...rest }) => {
	const dictionary = useDictionary("searchBar");

	const onDelete = useCallback(event => {
		if (event.nativeEvent instanceof KeyboardEvent) {
			if (event.key === "Enter" || event.key === " ") {
				event.preventDefault();
				event.stopPropagation();
				onChange(event, { value: '' });
			}
		} else {
			onChange(event, { value: '' });
		}
	}, [ onChange ]);

	return (
		<>
			<Dropdown
				className={`${className || ""} ${styles.searchBarDropdown}`}
				clearable
				icon={
					<div className={styles.searchBarSearchIconWrapper}>
						<Icon name="search" />
					</div>
				}
				placeholder={dictionary.searchPlaceholder || "Click to search ..."}
				fluid
				search
				selection
				options={options}
				onChange={onChange}
				value={value}
				loading={loading}
				tabIndex={0}
				{...rest}
			/>
			{loading && (
				<Loader active size="mini" className={styles.searchBarLoadingIcon} disabled={rest.disabled} />
			)}
			{!loading && value && (
				<Icon
					size="small"
					role="button"
					aria-label="Delete"
					name="delete"
					tabIndex={0}
					className={styles.searchBarDeleteIcon}
					onClick={onDelete}
					onKeyDown={onDelete}
					disabled={rest.disabled}
				/>
			)}
		</>
	);
};

SearchBar.propTypes = {
	className: PropTypes.string,
	options: PropTypes.array,
	onChange: PropTypes.func,
	value: PropTypes.string
};

export default SearchBar;
